import { Button, Dialog, DialogBody, DialogContent, DialogHeading, Modal } from '~/design-system/primitives'

interface Props {
  acceptAddNewPostalCode: (accept?: boolean) => void
}
function AcceptAddPostalCode({ acceptAddNewPostalCode }: Props) {
  return (
    <Modal className="bg-transparent max-w-[328px]" defaultOpen>
      <Dialog className="bg-white rounded-md max-w-[328px] pt-2.5 pr-5 pl-7">
        {({ close }) => (
          <DialogContent className="h-[70vhh] pt-3">
            <DialogHeading className="pb-0" slot="title">
              <div className="flex items-center justify-start w-full mb-1">
                <p className="text-primary-black text-lg font-semibold">Atenção! </p>
              </div>
            </DialogHeading>

            <div className="">
              <DialogBody className="mt-3">
                <p className="text-primary-black text-sm font-normal">
                  Ao alterar o CEP, os produtos e o preço disponíveis podem variar conforme a disponibilidade
                  na loja mais próxima de você. Deseja continuar e verificar os produtos disponíveis para o
                  novo CEP?
                </p>

                <div className="mt-6 gap-3 grid grid-cols-2">
                  <Button
                    className="border border-gray-40 "
                    onPress={() => {
                      acceptAddNewPostalCode(false)
                      close()
                    }}
                  >
                    Manter Cep
                  </Button>
                  <Button
                    className="bg-primary-orange text-white"
                    onPress={() => acceptAddNewPostalCode(true)}
                  >
                    Alterar Cep
                  </Button>
                </div>
              </DialogBody>
            </div>
          </DialogContent>
        )}
      </Dialog>
    </Modal>
  )
}

export default AcceptAddPostalCode
